import { Rating as MantineRating } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./rating.module.scss";
import type { CustomRatingFactory, IProps } from "./rating.types";

/**
 * Rating component wrapper.
 */
const Rating = componentWrapper<CustomRatingFactory, IProps>("Rating", (props, ref) => {
    return <MantineRating ref={ref} {...props} />;
});

export { Rating };
